import { createStructuredSelector } from "reselect";
import {
    UNSPSC_CLASS_LIST,
    UNSPSC_CLASS_LIST_SUCCESS,
    UNSPSC_CLASS_LIST_ERROR,
    UNSPSC_CLASS_PAGE_SET,
    UNSPSC_CLASS_HEADER,
    UNSPSC_CLASS_SEARCH_SET,
    UNSPSC_CLASS_SEARCH_CHANGE,
    UNSPSC_CLASS_ADD_SET,
    UNSPSC_CLASS_ADD_MODAL_SET,
    UNSPSC_CLASS_ADD,
    UNSPSC_CLASS_ADD_SUCCESS,
    UNSPSC_CLASS_ADD_ERROR,
    UNSPSC_CLASS_ADD_CHANGE,
    UNSPSC_CLASS_EDIT_SET,
    UNSPSC_CLASS_EDIT_CHANGE,
    UNSPSC_CLASS_EDIT_MODAL_SET,
    UNSPSC_CLASS_DETAIL,
    UNSPSC_CLASS_DETAIL_SUCCESS,
    UNSPSC_CLASS_DETAIL_ERROR,
    UNSPSC_CLASS_UPDATE,
    UNSPSC_CLASS_UPDATE_SUCCESS,
    UNSPSC_CLASS_UPDATE_ERROR
} from "../actions";

export const NAME = 'unspscClass';

export const UnspscClassList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: UNSPSC_CLASS_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const UnspscClassListSuccess = (data) => ({
    type: UNSPSC_CLASS_LIST_SUCCESS,
    payload: data
});

export const UnspscClassListError = (error) => ({
    type: UNSPSC_CLASS_LIST_ERROR,
    payload: error
});

export const UnspscClassPageSet = (data) => ({
    type: UNSPSC_CLASS_PAGE_SET,
    payload: data
});

export const UnspscClassHeader = (data) => ({
    type: UNSPSC_CLASS_HEADER,
    payload: data
})

export const UnspscClassSearchSet = (data) => ({
    type: UNSPSC_CLASS_SEARCH_SET,
    payload: data
});

export const UnspscClassSearchChangeSet = (data) => ({
    type: UNSPSC_CLASS_SEARCH_CHANGE,
    payload: data
});


export const UnspscClassAddChangeSet = (data) => ({
    type: UNSPSC_CLASS_ADD_CHANGE,
    payload: data
});

export const UnspscClassAddSet = (data) => ({
    type: UNSPSC_CLASS_ADD_SET,
    payload: data
});

export const UnspscClassAddModalSet = (data) => ({
    type: UNSPSC_CLASS_ADD_MODAL_SET,
    payload: data
});

export const UnspscClassAdd = (data) => ({
    type: UNSPSC_CLASS_ADD,
    payload: data
});

export const UnspscClassAddSuccess = (message) => ({
    type: UNSPSC_CLASS_ADD_SUCCESS,
    payload: message
});

export const UnspscClassAddError = (error) => ({
    type: UNSPSC_CLASS_ADD_ERROR,
    payload: error
});

export const UnspscClassEditSet = (data) => ({
    type: UNSPSC_CLASS_EDIT_SET,
    payload: data
});

export const UnspscClassEditChangeSet = (data) => ({
    type: UNSPSC_CLASS_EDIT_CHANGE,
    payload: data
});

export const UnspscClassEditModalSet = (data) => ({
    type: UNSPSC_CLASS_EDIT_MODAL_SET,
    payload: data
});

export const UnspscClassEditTabSet = (data) => ({
    type: UNSPSC_CLASS_EDIT_TAB_SET,
    payload: data
});

export const UnspscClassDetail = (data) => ({
    type: UNSPSC_CLASS_DETAIL,
    payload: data
});

export const UnspscClassDetailSuccess = (data) => ({
    type: UNSPSC_CLASS_DETAIL_SUCCESS,
    payload: data
});

export const UnspscClassDetailError = (error) => ({
    type: UNSPSC_CLASS_DETAIL_ERROR,
    payload: error
});

export const UnspscClassUpdate = (data) => ({
    type: UNSPSC_CLASS_UPDATE,
    payload: data
});

export const UnspscClassUpdateSuccess = (message) => ({
    type: UNSPSC_CLASS_UPDATE_SUCCESS,
    payload: message
});

export const UnspscClassUpdateError = (error) => ({
    type: UNSPSC_CLASS_UPDATE_ERROR,
    payload: error
});

const unspscClass = (state) => state[NAME];

export const UnspscClassSelector = createStructuredSelector({
    unspscClass
})
